import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ProjectMasterService } from "src/app/Service/projectmaster/projectmaster.service";
import { IProjectCreateModel, IProjectMasterViewModel } from "src/app/ViewModel/ProjectMasterModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from "src/app/Service/notification.service";
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { IOrganizationViewModel } from 'src/app/ViewModel/OrganizationModel';

@Component({
    selector: 'app-master-project-dialog',
    templateUrl: './edit-project.component.html'
})
export class EditProjectComponent implements OnInit {
    projStartDate = new Date();
    projEndDate = new Date();
    icList: RoleFeatureModel[] = [];
    businessGroups: IOrganizationViewModel[] = [];
    groupid: number | null | undefined;
    public actionButtonText: string = "Save";
    memberId: number | undefined;
    visible_BG: boolean = false;
    icid: null | number | undefined;
    public numFormat: string | undefined;
    public projectForm: FormGroup = new FormGroup({
        projDesc: new FormControl('', [Validators.required]),
        projShortDesc: new FormControl('', [Validators.required]),
        projDisName: new FormControl(''),
        projCode: new FormControl('', [Validators.required]),
        jobCode: new FormControl('', [Validators.required]),
        projUrl: new FormControl('', [Validators.required]),
        iC_Id: new FormControl(),
        ICId: new FormControl(),
        projLogoUrl: new FormControl(),
        projStatus: new FormControl(true),
        projStartDate: new FormControl(),
        projEndDate: new FormControl(),
        projIsCloudStorage: new FormControl(false),
        Doc_Number_Format: new FormControl(),
        businessGroup: new FormControl(),
        client: new FormControl(),
        consultant: new FormControl(),
        isoNo: new FormControl(),
        latitude: new FormControl(),
        longitude:new FormControl()
    });

    constructor(private _projService: ProjectMasterService, private _commonService: CommonService, public _dialogRef: MatDialogRef<EditProjectComponent>,
        private _notificationService: NotificationService, public mapRoleFeatureService: MapRoleFeatureService,
        @Inject(MAT_DIALOG_DATA) public _data: IProjectCreateModel) {

    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {
        this.numFormat = 'Auto';
        this.projectForm.get('Doc_Number_Format')?.setValue(this.numFormat);
        this.memberId = this._commonService.getLoggedInUserId();
        if (this._data && this._data.icList)
            this.icList = this._data.icList;
        if (this._data && this._data.businessGroups)
            this.businessGroups = this._data.businessGroups;
        if (!!this._data.project)
            this.setFormValues();
        if (this._data.project != null && !this._data.isImport) {
            this.actionButtonText = "Update";
        }
        else
            this.visible_BG = true;

    }
    /**
     * Set form values
     */
    setFormValues() {

        this.projectForm.get('projDesc')?.setValue(this._data.project.project_Description);
        this.projectForm.get('projShortDesc')?.setValue(this._data.project.project_Short_Description);
        this.projectForm.get('projCode')?.setValue(this._data.project.project_Code);
        this.projectForm.get('jobCode')?.setValue(this._data.project.job_Code);
        this.projectForm.get('projUrl')?.setValue(this._data.project.project_URL);
        this.projectForm.get('projLogoUrl')?.setValue(this._data.project.project_Logo_URL);
        this.projectForm.get('projStatus')?.setValue(this._data.project.is_Active);
        this.projectForm.get('projIsCloudStorage')?.setValue(this._data.project.is_Cloud_Storage);
        this.projectForm.get('Doc_Number_Format')?.setValue(this._data.project.doc_Number_Format);
        this.projectForm.get('iC_Id')?.setValue(this._data.project.iC_Id);
        this.projectForm.get('client')?.setValue(this._data.project.client);
        this.projectForm.get('consultant')?.setValue(this._data.project.consultant);
        this.projectForm.get('isoNo')?.setValue(this._data.project.isoFormatNo);
        this.projectForm.get('latitude')?.setValue(this._data.project.latitude);
        this.projectForm.get('longitude')?.setValue(this._data.project.longitude);
        this.numFormat = this._data.project.doc_Number_Format;
        if (this.icList && this.icList.some(x => x.dedId == this._data.project.iC_Id)) {
            let objIC = this.icList.filter(x => x.dedId == this._data.project.iC_Id)[0];
            this.projectForm.get('ICId')?.setValue(objIC.dedDescription);
            this.icid = this._data.project.iC_Id;
        }

        if (!!this._data.project.start_Date) {
            this.projectForm.get('projStartDate')?.setValue(this._data.project.start_Date);
            this.projStartDate = this._data.project.start_Date;
        }
        if (!!this._data.project.end_Date) {
            this.projectForm.get('projEndDate')?.setValue(this._data.project.end_Date);
            this.projEndDate = this._data.project.end_Date;
        }
    }
    /**
     * Save project
     */
    saveProject() {
        let projMaster: any | IProjectMasterViewModel = {
            project_Code: this.getFormValue('projCode'), project_Description: this.getFormValue('projDesc'),
            project_Short_Description: this.getFormValue('projShortDesc'), job_Code: this.getFormValue('jobCode'),
            project_URL: this.getFormValue('projUrl'), project_Logo_URL: this.getFormValue('projLogoUrl'),
            start_Date: this.getFormValue('projStartDate'), end_Date: this.getFormValue('projEndDate'),
            is_Cloud_Storage: this.getFormValue('projIsCloudStorage'), is_Active: this.getFormValue('projStatus'),
            doc_Number_Format: this.getFormValue('Doc_Number_Format'),
            client: this.getFormValue('client'),
            consultant: this.getFormValue('consultant'),
            isoFormatNo: this.getFormValue('isoNo'),
            latitude: this.getFormValue('latitude'),
            longitude: this.getFormValue('longitude'),
            project_Type: 'Others', user_Id: this.memberId,
            iC_Id: this.icid,
            group_Id: this.groupid
        };
        if (!(!!projMaster.start_Date) || !(!!projMaster.end_Date)) {
            this._notificationService.showPopup("Kindly select project start & end date", "Warning");
            return;
        }
        if (!projMaster.iC_Id) {
            this._notificationService.showPopup("Kindly select IC", "Warning");
            return;
        }
        if (this._data.project != null && !this._data.isImport)
            projMaster.project_Id = this._data.project.project_Id;
        if (this._data.isImport) {
            projMaster.project_Type = this._data.project.project_Type;
        }
        this._projService.insertUpdateProject(projMaster).subscribe((res: StandardOutputModel) => {
            if (res.successCode == 200) {
                if (this._data == null)
                    projMaster.project_Id = +res.result;
                this._dialogRef.close({ response: res, project: projMaster });
            }
            else {
                this._dialogRef.close({ response: res });
            }
        }, err => {

        });
    }

    /**
     * Get GroupForm Controls value
     * @param controlName ControlName
     */
    getFormValue(controlName: string): any {
        return this.projectForm.get(controlName)?.value;
    }

    getStartDateValue(selectedText: any) {
        this.projectForm.get('projStartDate')?.setValue(selectedText);
    }

    getEndDateValue(selectedText: any) {
        this.projectForm.get('projEndDate')?.setValue(selectedText);
    }

    /**
     * Close modal dialog
     */
    closeDialog() {
        this._dialogRef.close();
    }

    changeIc(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
        //this.clearIcSelected = 'N';		
        this.icid = event.value != '-2' ? parseInt(event.value.toString()) : null;

    }

    changebusinessGroup(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
        //this.clearIcSelected = 'N';		
        this.groupid = event.value != '-2' ? parseInt(event.value.toString()) : null;

    }
    onKeyPress(event: KeyboardEvent): void {
        const inputValue = (event.target as HTMLInputElement).value;
        const key = event.key;
        const cursorPosition = (event.target as HTMLInputElement).selectionStart;
    
        if (key === 'Backspace' || key === 'Delete') {
          return;
        }
        if (event.ctrlKey && key === 'a') {
            return;
        }
        if (event.ctrlKey && key === 'c') {
            return;
        }
        if (event.ctrlKey && key === 'v') {
            return;
        }

        const updatedValue =
          inputValue.slice(0, cursorPosition) + key + inputValue.slice(cursorPosition);
    
        const validCharactersRegex = /^[-]?\d+(\.\d{0,})?$/;
    
        if (!validCharactersRegex.test(updatedValue)) {
          event.preventDefault();
        }
      }

}